import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/face-happy.svg';
import { Icon } from '../Icon/Icon';
export const FaceHappyIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
